import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';
import { RepeatableState } from '@/store/modules/repeatable/state';
import { RepeatableDataMap } from '@/store/modules/repeatable/types';

export type Getters<S = RepeatableState> = {
  getData(state: S): RepeatableDataMap;
};

export interface NamespacedGetters {
  'repeatable/getData': RepeatableDataMap;
}

export const getters: GetterTree<RepeatableState, RootState> & Getters = {
  getData(state: RepeatableState): RepeatableDataMap {
    return state.data;
  }
};
